import styled from 'styled-components';
import Link from '@mui/material/Link';
import { Colors } from '../../../theme';
import { breakpointLG } from '../styles/breakpoints';
export const Wrapper = styled.div `
  display: flex;
`;
export const CustomLink = styled(Link) `
  display: flex;
  padding: 0 16px 0 0;
  margin: 0 16px 0 0;
  border-right: solid 1px ${Colors.black40};

  &:last-child {
    padding: 0;
    margin: 0;
    border-right: 0;
  }
`;
export const CustomImage = styled.img `
  min-width: 0;
  max-width: 124px;
  max-height: 28px;

  @media (min-width: ${breakpointLG}) {
    max-width: 180px;
    max-height: 40px;
  }
`;
//# sourceMappingURL=styles.js.map